<template>
  <MonitorWrapper class="ht200-monitor">
    <Alarm v-if="stateOpt.isAlarm" />
    <Normal v-else />
  </MonitorWrapper>
</template>

<script>
import monitorMixin from '@/mixins/monitorMixin';
import Alarm from './components/alarm.vue';
import Normal from './components/normal.vue';
import { getOptions } from '@/utils/deviceUtils/state';
import { fieldDict, HT200StatusUtil } from './utils';

export default {
  mixins: [monitorMixin],
  components: {
    Alarm,
    Normal
  },
  data() {
    return {
      statusOptions: [
        { label: '检测状态', prop: 'runStatus', show: () => true },
        { label: '配置电场模式', prop: 'configFieldType', show: () => this.hasMonitoring },
        { label: '当前电场模式', prop: 'currentFieldType', show: () => this.hasMonitoring },
        { label: '对齐因子', prop: 'factor', show: () => this.hasMonitoring }
      ],
      monitoringOptions: [
        { label: '管加热器监控电压', prop: 'heat1Voltage', unit: 'mV' },
        { label: '迁移泵监控电压', prop: 'migrationPumpVoltage', unit: 'mV' },
        { label: '采样泵监控电压', prop: 'samplePumpVoltage', unit: 'mV' },
        { label: '管加热器目标温度', prop: 'heat1TargetTemp', unit: '℃' },
        { label: '管加热器实际温度', prop: 'heat1Temp', unit: '℃' },
        { label: '电池电压', prop: 'batteryVoltage', unit: 'mV' },
        { label: '膜加热器监控电压', prop: 'heat2Voltage', unit: 'mV' },
        { label: '反吹泵监控电压', prop: 'backFlushPumpVoltage', unit: 'mV' },
        { label: '膜加热器目标温度', prop: 'heat2TargetTemp', unit: '℃' },
        { label: '膜加热器实际温度', prop: 'heat2Temp', unit: '℃' },
        { label: '环境温度', prop: 'temp', unit: '℃' },
        { label: '环境气压', prop: 'pressure', unit: 'hPa' },
        { label: '环境相对湿度', prop: 'humidity', unit: '%' },
        { label: '迁移管温度', prop: 'migrationTemp', unit: '℃' },
        { label: '迁移管气压', prop: 'migrationPressure', unit: 'hPa' },
        { label: '迁移管相对湿度', prop: 'migrationHumidity', unit: '%' },
        { label: '进气口温度', prop: 'inletTemp', unit: '℃' },
        { label: '进气口气压', prop: 'inletPressure', unit: 'hPa' },
        { label: '进气口相对湿度', prop: 'inletHumidity', unit: '%' },
        { label: '进气口加热器监控电压', prop: 'heat3Voltage', unit: 'mV' },
        { label: '进气口加热器目标温度', prop: 'heat3TargetTemp', unit: '℃' },
        { label: '进气口加热器实际温度', prop: 'heat3Temp', unit: '℃' }
      ],
      j218StateData: {
        runStatus: 0, // 检测状态
        configFieldType: 0, // 配置电场模式
        currentFieldType: 0, // 当前电场模式
        factor: 0, // 对齐因子
        subsReportDto: null
      },
      j218Data: {
        heat1Voltage: '', // 管加热器监控电压，单位:mV
        migrationPumpVoltage: '', // 迁移泵监控电压，单位:mV
        samplePumpVoltage: '', // 采样泵监控电压，单位:mV
        heat1TargetTemp: '', // 管加热器目标温度，单位:摄氏度
        heat1Temp: '', //管加热器实际温度，单位:摄氏度
        batteryVoltage: '', // 电池电压，单位:mV
        heat2Voltage: '', // 膜加热器监控电压，单位:mV
        backFlushPumpVoltage: '', //反吹泵监控电压，单位:mV
        heat2TargetTemp: '', // 膜加热器目标温度，单位:摄氏度
        heat2Temp: '', // 膜加热器实际温度，单位:摄氏度
        temp: '', // 环境温度，单位:摄氏度
        pressure: '', //环境气压，单位:hPa
        humidity: '', // 环境相对湿度，单位:%
        migrationTemp: '', // 迁移管温度，单位:摄氏度
        migrationPressure: '', //迁移管气压，单位:hPa
        migrationHumidity: '', // 迁移管相对湿度，单位:%
        inletTemp: '', // 进气口温度，单位:摄氏度
        inletPressure: '', // 进气口气压，单位:hPa
        inletHumidity: '', // 进气口相对湿度，单位:%
        heat3Voltage: '', //进气口加热器热器监控电压，单位:mV
        heat3TargetTemp: '', // 进气口加热器目标温度，单位:摄氏度
        heat3Temp: '' // 进气口加热器实际温度，单位:摄氏度
      },
      stateOpt: {
        isAlarm: false
      }
    };
  },
  provide() {
    return {
      getRoot: () => this
    };
  },
  computed: {
    hasMonitoring() {
      return false;
    }
  },
  methods: {
    updateData(res) {
      try {
        const { mods, runstate, state } = res;
        const { ht200Mod } = mods;
        const { runStatus, configFieldType, currentFieldType } = ht200Mod.j218RunStatDto;

        this.stateOpt = getOptions(runstate, state);

        Object.assign(this.j218StateData, ht200Mod.j218RunStatDto, {
          runStatus: HT200StatusUtil.getStateText(runStatus),
          configFieldType: fieldDict.enum[configFieldType].text,
          currentFieldType: fieldDict.enum[currentFieldType].text
        });

        Object.assign(this.j218Data, ht200Mod.j218DeviceMonDataDto);
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss"></style>
